module.exports = __webpack_public_path__ + "static/media/lock.4ba541aa.svg";